"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.betweenSemverMatcherContext = void 0;
var Semver_1 = require("../../utils/Semver");
function betweenSemverMatcherContext(ruleAttr) {
    var startSemver = new Semver_1.Semver(ruleAttr.start);
    var endSemver = new Semver_1.Semver(ruleAttr.end);
    return function betweenSemverMatcher(runtimeAttr) {
        var runtimeSemver = new Semver_1.Semver(runtimeAttr);
        var isBetween = startSemver.compare(runtimeSemver) <= 0 && endSemver.compare(runtimeSemver) >= 0;
        return isBetween;
    };
}
exports.betweenSemverMatcherContext = betweenSemverMatcherContext;
